import React, { Component } from 'react'
import { graphql } from 'react-apollo'
import './modal.css'
import {
  newTracker,
  updateTracker,
  deleteTracker
} from '@/graphql/mutations/tracker'
import { GC_USER_ID } from '@/constants'
import DeleteModal from '../modals/Delete'

import { Modal, Paper, Checkbox, Button } from 'material-ui'
import List, { ListItem, ListItemText, ListItemIcon } from 'material-ui/List'
import TextField from 'material-ui/TextField'
import Select from 'material-ui/Select'
import { MenuItem } from 'material-ui/Menu'
import { InputLabel } from 'material-ui/Input'
import { FormControl, FormGroup, FormControlLabel } from 'material-ui/Form'
import IconButton from 'material-ui/IconButton'
import ClearIcon from 'material-ui-icons/Clear'
import TimelapseIcon from 'material-ui-icons/Timelapse'
import AssignmentIcon from 'material-ui-icons/Assignment'
import SentimentSatisfiedIcon from 'material-ui-icons/SentimentSatisfied'
import ChevronRightIcon from 'material-ui-icons/ChevronRight'
import StarIcon from 'material-ui-icons/Star'
import StarBorderIcon from 'material-ui-icons/StarBorder'
import Loading from './Loading'

@graphql(newTracker, {
  name: 'newTracker',
  options: {
    refetchQueries: ['trackersQuery']
  }
})
@graphql(updateTracker, {
  name: 'updateTracker',
  options: {
    refetchQueries: ['trackersQuery']
  }
})
@graphql(deleteTracker, {
  name: 'deleteTracker',
  options: {
    refetchQueries: ['trackersQuery']
  }
})
export default class TrackerEditModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false,
      OpenDelete: false,
      tracker: '',
      loadingTracker: false,
      loadingDel: false
    }
  }

  // reset state if the seeded prop is updated
  componentWillReceiveProps(nextProps) {
    if (nextProps.open !== this.props.open) {
      this.setState({ open: nextProps.open })
    }

    if (nextProps.tracker !== this.props.tracker) {
      this.setState({ tracker: nextProps.tracker })
    }
  }

  handleSaveTracker = () => {
    this.setState({ loadingTracker: true })
    if (this.props.action === 'add') {
      this.props
        .newTracker({
          variables: {
            name: this.state.tracker.name,
            category: this.state.tracker.category,
            isStared: this.state.tracker.isStared,
            isDuration: this.state.tracker.isDuration,
            color: this.state.tracker.color,
            isPublic: this.state.tracker.isPublic,
            type: this.state.tracker.type,
            userId: global.localStorage.getItem(GC_USER_ID)
          }
        })
        .then(() => {
          this.props.onClose()
          this.setState({
            open: false,
            loadingTracker: false
          })
        })
        .catch(error => {
          console.log(error.message + ' Please refresh.')
          this.props.onClose()
          this.setState({
            open: false,
            loadingTracker: false
          })
        })
    } else if (this.props.action === 'edit') {
      this.props
        .updateTracker({
          variables: {
            name: this.state.tracker.name,
            category: this.state.tracker.category,
            isStared: this.state.tracker.isStared,
            isDuration: this.state.tracker.isDuration,
            color: this.state.tracker.color,
            isPublic: this.state.tracker.isPublic,
            type: this.state.tracker.type,
            id: this.state.tracker.id,
            userId: global.localStorage.getItem(GC_USER_ID)
          }
        })
        .then(() => {
          this.props.onClose()
          this.setState({
            open: false,
            loadingTracker: false
          })
        })
        .catch(error => {
          console.log(error.message + ' Please refresh.')
          this.props.onClose()
          this.setState({
            open: false,
            loadingTracker: false
          })
        })
    }
  }

  handleChangeTracker = name => event => {
    var newTracker = Object.assign({}, this.state.tracker)
    switch (name) {
      case 'isPublic':
      case 'isDuration':
      case 'isStared':
        newTracker[name] = !this.state.tracker[name]
        break
      default:
        newTracker[name] = event.target.value
        break
    }
    this.setState({ tracker: newTracker })
  }

  handleClose = () => {
    this.props.onClose()
    this.setState({
      open: false
    })
  }

  handleOpenDelete = () => {
    this.setState({
      OpenDelete: true
    })
  }

  handleCloseDelete = () => {
    this.setState({
      OpenDelete: false
    })
  }

  handleDelete = id => {
    this.setState({ loadingTracker: true, loadingDel: true })
    this.props
      .deleteTracker({
        variables: {
          id: id
        }
      })
      .then(() => {
        this.props.onClose()
        this.setState({
          loadingDel: false,
          OpenDelete: false,
          open: false,
          loadingTracker: false
        })
      })
      .catch(error => {
        console.log(error.message + ' Please refresh.')
        this.props.onClose()
        this.setState({
          loadingDel: false,
          OpenDelete: false,
          open: false,
          loadingTracker: false
        })
      })
  }

  render() {
    return (
      <div>
        <Modal
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          open={this.state.open}
          onClose={this.handleClose}
          className="modalAddToday"
          disableAutoFocus
        >
          <Paper className="paperAddTodayEdit" style={{ borderRadius: 16 }}>
            <div id="clearBtnBedTime" className="divAddTpday">
              <div className="divClearButton">
                <IconButton
                  className="btn btn-default btn-style"
                  onClick={this.handleClose}
                >
                  <ClearIcon className="iconClear" />
                </IconButton>
              </div>
              {this.state.tracker && (
                <List>
                  <ListItem className="listItemSleepTimeComplete">
                    <ListItemIcon>
                      <TimelapseIcon className="editIcons" />
                    </ListItemIcon>
                    <TextField
                      id="name"
                      label="Tracker Name"
                      className="textFieldLong"
                      value={
                        this.state.tracker.name ? this.state.tracker.name : ''
                      }
                      onChange={this.handleChangeTracker('name')}
                      margin="normal"
                      InputLabelProps={{
                        className: 'textFieldTimeTiny'
                      }}
                      inputProps={{
                        className: 'textFieldTimeSmall'
                      }}
                    />
                  </ListItem>

                  <ListItem className="modalContentSmallTime">
                    <ListItemIcon>
                      <AssignmentIcon className="iconSleepAtTimeDate" />
                    </ListItemIcon>
                    <FormControl className="textField">
                      <InputLabel htmlFor="type">Type</InputLabel>
                      <Select
                        value={this.state.tracker.type}
                        onChange={this.handleChangeTracker('type')}
                        inputProps={{
                          name: 'type',
                          id: 'type'
                        }}
                      >
                        <MenuItem value="" />
                        <MenuItem value={'project'}>Project</MenuItem>
                        <MenuItem value={'reading'}>Reading</MenuItem>
                        <MenuItem value={'sleep'}>Sleep</MenuItem>
                        <MenuItem value={'bodyweight'}>Body Weight</MenuItem>
                        <MenuItem value={'checked'}>
                          <span role="img" aria-label="emoji">
                            ✅
                          </span>
                        </MenuItem>
                        <MenuItem value={'energy'}>Energy</MenuItem>
                        <MenuItem value={'dont'}>Dont's</MenuItem>
                      </Select>
                    </FormControl>
                    <ListItemIcon>
                      <SentimentSatisfiedIcon className="iconSleepScore" />
                    </ListItemIcon>
                    <FormControl className="textField">
                      <InputLabel htmlFor="color">Color</InputLabel>
                      <Select
                        value={this.state.tracker.color}
                        onChange={this.handleChangeTracker('color')}
                        inputProps={{
                          name: 'color',
                          id: 'color'
                        }}
                      >
                        <MenuItem value="" />
                        <MenuItem value={'rgba(147, 112, 219,0.6)'}>
                          <span style={{ color: 'rgba(147, 112, 219,0.6)' }}>
                            purple
                          </span>
                        </MenuItem>
                        <MenuItem value={'rgba(100,149,237,0.3)'}>
                          <span style={{ color: 'rgba(100,149,237,0.3)' }}>
                            blue
                          </span>
                        </MenuItem>
                        <MenuItem value={'rgba(0,191,255,0.4)'}>
                          <span style={{ color: 'rgba(0,191,255,0.4)' }}>
                            lightblue
                          </span>
                        </MenuItem>
                        <MenuItem value={'rgba(32,178,170,0.6)'}>
                          <span style={{ color: 'rgba(32,178,170,0.6)' }}>
                            bluegreen
                          </span>
                        </MenuItem>
                        <MenuItem value={'rgba(0,128,0,0.5)'}>
                          <span style={{ color: 'rgba(0,128,0,0.5)' }}>
                            green
                          </span>
                        </MenuItem>
                        <MenuItem value={'rgba(144,238,144,0.6)'}>
                          <span style={{ color: 'rgba(144,238,144,0.6)' }}>
                            lightgreen
                          </span>
                        </MenuItem>
                        <MenuItem value={'rgba(255,165,0,0.5)'}>
                          <span style={{ color: 'rgba(255,165,0,0.5)' }}>
                            orange
                          </span>
                        </MenuItem>
                        <MenuItem value={'rgba(160,82,45,0.4)'}>
                          <span style={{ color: 'rgba(160,82,45,0.4)' }}>
                            brown
                          </span>
                        </MenuItem>
                        <MenuItem value={'rgba(255,105,180,0.6)'}>
                          <span style={{ color: 'rgba(255,105,180,0.6)' }}>
                            pink
                          </span>
                        </MenuItem>
                        <MenuItem value={'rgba(255,0,0,0.4)'}>
                          <span style={{ color: 'rgba(255,0,0,0.4)' }}>
                            red
                          </span>
                        </MenuItem>
                        <MenuItem value={'rgba(128,128,128,0.4)'}>
                          <span style={{ color: 'rgba(128,128,128,0.4)' }}>
                            grey
                          </span>
                        </MenuItem>
                        <MenuItem value={'rgba(211,211,211,0.6)'}>
                          <span style={{ color: 'rgba(211,211,211,0.6)' }}>
                            lightgrey
                          </span>
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </ListItem>
                  <ListItem className="listItemSleepTimeComplete">
                    <FormGroup row style={{ paddingLeft: 30 }}>
                      {this.state.tracker.type !== 'project' && (
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={!this.state.tracker.isPublic}
                              onChange={this.handleChangeTracker('isPublic')}
                              value="isPublic"
                              style={{ color: 'lightblue' }}
                            />
                          }
                          label="Private"
                        />
                      )}
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={this.state.tracker.isDuration}
                            onChange={this.handleChangeTracker('isDuration')}
                            value="isDuration"
                            style={{ color: 'lightblue' }}
                          />
                        }
                        label="Duration"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            icon={<StarBorderIcon />}
                            checkedIcon={<StarIcon />}
                            checked={this.state.tracker.isStared}
                            onChange={this.handleChangeTracker('isStared')}
                            value="isStared"
                            style={{ color: 'lightblue' }}
                          />
                        }
                        label="Starred"
                      />
                    </FormGroup>
                  </ListItem>
                  <ListItem className="modalContentSmallTime">
                    <ListItemIcon>
                      <AssignmentIcon className="iconSleepAtTimeDate" />
                    </ListItemIcon>
                    <FormControl className="textField">
                      <InputLabel htmlFor="category">Category</InputLabel>
                      <Select
                        value={this.state.tracker.category}
                        onChange={this.handleChangeTracker('category')}
                        inputProps={{
                          name: 'category',
                          id: 'category'
                        }}
                      >
                        <MenuItem value="" />
                        <MenuItem value={'Very Productive'}>
                          Very Productive
                        </MenuItem>
                        <MenuItem value={'Productive'}>Productive</MenuItem>
                        <MenuItem value={'Maintenance'}>Maintenance</MenuItem>
                        <MenuItem value={'Distracting'}>Distracting</MenuItem>
                        <MenuItem value={'Very Distracting'}>
                          Very Distracting
                        </MenuItem>
                        <MenuItem value={'Personal'}>Personal</MenuItem>
                        <MenuItem value={'Workout'}>Workout</MenuItem>
                      </Select>
                    </FormControl>
                  </ListItem>
                  <ListItem className="modalContentDone">
                    {this.props.action === 'edit' && (
                      <Button
                        onClick={this.handleOpenDelete}
                        className="iconBtnCheck"
                        size="small"
                      >
                        {' '}
                        <span style={{ color: 'grey', fontSize: 15 }}>
                          Delete
                        </span>
                      </Button>
                    )}
                    <ListItemText />
                    <Button
                      onClick={this.handleClose}
                      className="iconBtnCheck"
                      size="small"
                    >
                      {' '}
                      <span style={{ color: 'grey', fontSize: 15 }}>
                        Cancel
                      </span>
                    </Button>
                    <Button
                      onClick={this.handleSaveTracker}
                      className="iconBtnCheck"
                      size="small"
                    >
                      {' '}
                      <span style={{ color: 'grey', fontSize: 15 }}>Save</span>
                      {this.state.loadingTracker ? (
                        <Loading />
                      ) : (
                        <ChevronRightIcon
                          style={{
                            color: 'grey',
                            fontSize: 20,
                            paddingLeft: 10
                          }}
                        />
                      )}
                    </Button>
                  </ListItem>
                </List>
              )}
            </div>
          </Paper>
        </Modal>
        <DeleteModal
          open={this.state.OpenDelete}
          onClose={this.handleCloseDelete}
          yes={() => this.handleDelete(this.state.tracker.id)}
          loading={this.state.loadingDel}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/modals/TrackerEdit.js